import { render, staticRenderFns } from "./MentTag.vue?vue&type=template&id=5e75768e&"
import script from "./MentTag.vue?vue&type=script&lang=js&"
export * from "./MentTag.vue?vue&type=script&lang=js&"
import style0 from "./MentTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports